<script setup lang="ts">
import Banner from './components/banner/index.vue';
import Information from './components/information/index.vue';
import EventCalendar from './components/EventCalendar.vue';
import Content from './components/content/index.vue';
import CommunityCard from './components/CommunityCard.vue';
import OperationCard from './components/OperationCard.vue';
import Footer from './components/Footer.vue';
import Sidebar from './components/Sidebar.vue';
import ScrollToTop from './components/ScrollToTop.vue';

const props = defineProps({
  options: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<template>
  <section class="bg-hex-fafafa">
    <Sidebar />
    <ScrollToTop />
    <div class="pb-124">
      <Banner v-if="props.options.Banner == 1 || props.options.CommunityData == 1" />
    </div>
    <div class="mt-48 container">
      <Information v-if="props.options.Information == 1" />
    </div>
    <div class="mt-48">
      <EventCalendar v-if="props.options.EventCalendar == 1" />
    </div>
    <div class="flex translate-y--56 justify-between container">
      <div class="flex-grow">
        <Content v-if="props.options.Recommend == 1" />
      </div>
      <div class="ml-32 w-376 flex-shrink-0">
        <CommunityCard v-if="props.options.CommunityCard == 1" />
        <OperationCard v-if="props.options.OperationCard == 1" />
        <Footer />
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
</style>
